export function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="relative z-10 mt-32 border-t border-line">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
        <div className="md:col-span-5">
          <div
            className="text-[2.4rem] text-text leading-none"
            style={{ fontFamily: 'var(--font-sans)', fontVariationSettings: '"wdth" 92, "opsz" 96', fontWeight: 600, letterSpacing: '-0.04em' }}
          >
            haevi
          </div>
          <p className="mt-3 text-text-2 text-[0.98rem] leading-relaxed max-w-sm">
            A video agent that sits inside <span className="text-text font-semibold">one sentence</span>.
          </p>
          <div className="mt-5 flex items-center gap-2 t-mono-caps">
            <span className="live-dot" />
            <span>Agent online · {year}</span>
          </div>
        </div>

        <div className="md:col-span-3 t-mono-caps space-y-2">
          <div className="text-text-2 mb-2">Product</div>
          <div><a className="text-text hover:text-accent transition-colors" href="/dashboard">Workspace</a></div>
          <div><a className="text-text hover:text-accent transition-colors" href="/templates">Templates</a></div>
          <div><a className="text-text hover:text-accent transition-colors" href="/actors">Cast</a></div>
        </div>

        <div className="md:col-span-4 md:text-right t-mono-caps space-y-2">
          <div>Ships vertical and wide</div>
          <div>Eight seconds to four minutes</div>
          <div className="text-text-3">© {year} haevi</div>
        </div>
      </div>
    </footer>
  )
}
